<template>
    <div class="col dashboard-left-menu ">
        <ul>
            <li>
                <a href="javascript://"  @click="Menunav('Home')" v-bind:class="{active: type =='OverView'}"><span class="text">Overview</span> 
                <!-- <span class="notfication-circle" v-if="updation_ov"></span> -->
                </a>
            </li>
            <li>
                <a href="javascript://" @click="Menunav('business_setup')" v-bind:class="{active: type =='BS'}"><span class="text">Business Set-up</span>
                <!-- <span class="notfication-circle" v-if="updation_bs"></span> -->
                </a>
            </li>
            <li>
                <a href="javascript://" @click="Menunav('accounting_service')" v-bind:class="{active: type =='AS'}"><span class="text">Accounting Services</span>
                <!-- <span class="notfication-circle" v-if="updation_as"></span> -->
                </a>
            </li>
            <li>
                <a href="javascript://"  @click="Menunav('ask_an_expert')"  v-bind:class="{active: type =='AAE'}"> <span class="text">Ask an Expert</span>
                <!-- <span class="notfication-circle"></span> -->
                </a>
            </li>
            <li>
                <a href="javascript://" @click="Menunav('grievances')" v-bind:class="{active: type =='grievances'}"><span class="text">Grievances</span>
                <!-- <span class="notfication-circle"></span> -->
                </a>
            </li>
            <li>
                <a href="javascript://" @click="Menunav('billing')" v-bind:class="{active: type =='billing'}"><span class="text">Billing</span>
                <!-- <span class="notfication-circle"></span> -->
                </a>
            </li>
             <!-- <li>
                <a href="javascript://" @click="Menunav('documents')" v-bind:class="{active: type =='documents'}"><span class="text">Documents</span>
                <span class="notfication-circle"></span>
                </a>
            </li> -->
            <li>
                <a href="javascript://" @click="Menunav('call_details')" v-bind:class="{active: type =='call_details'}"><span class="text">Call Details</span>
                </a>
            </li>
        </ul>
        <!-- <div class="notfication-circle">

        </div>
        <button class="sidenavselect">Notification</button>

        <a  href="javascript://"  class="drop-box1" style="">
             <button class="sidenavselect"  v-bind:class="{active: type =='BS'}">Business set-up </button>
        </a>
        <a  href="javascript://"  class="drop-box1">
            <button class="sidenavselect" v-bind:class="{active: type =='AS'}"> Account Service</button>
        </a>
        <button class="sidenavselect" >As an Expert</button>
        <button class="sidenavselect">Grievances</button>
        <button class="sidenavselect">Billing</button> -->
    </div>
</template>
<script>
export default {
    name:'left-menu',
    props:['type'],
    data() {
        return {
            updation_ov:true,
            updation_bs:false,
            updation_as:false,
        };
    },
    methods:{
        Menunav(to){
            this.$router.push({name:to});
            // window.location.href ='/workspace/'+to+'/'+activity_type
        }
    }

};
</script>
<style scoped>
.active{
    color: #ffffff;background-color: #000
}
</style>
